export enum CountryCode
{
    USA = 'USA',
    CAN = 'CAN'
}